// extracted by mini-css-extract-plugin
module.exports = {"MuiPaper-root":"datePicker_MuiPaper-root__Wbk-N","MuiPaper-elevation24":"datePicker_MuiPaper-elevation24__19NHC"};